import { ShieldCheck } from "lucide-react";

export const GuaranteeSeal = ({ size = "md", dark = false }) => {
  const big = size === "lg";
  return (
    <div className={`inline-flex items-center gap-3 ${dark ? "text-white" : "text-emerald-900"}`} data-testid="guarantee-seal">
      <span
        className={`relative flex items-center justify-center rounded-full ${dark ? "bg-white text-emerald-900" : "bg-emerald-900 text-white"} ${big ? "h-16 w-16" : "h-10 w-10"} ring-4 ${dark ? "ring-white/20" : "ring-emerald-900/10"}`}
      >
        <ShieldCheck size={big ? 30 : 20} strokeWidth={2.2} aria-hidden="true" />
      </span>
      <span className="leading-tight">
        <span className={`block font-display font-extrabold tracking-tight ${big ? "text-2xl" : "text-base"}`}>Garanzia Rocard</span>
        <span className={`block text-xs ${dark ? "text-emerald-100" : "text-gray-600"}`}>Acquisto protetto</span>
      </span>
    </div>
  );
};
